/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import React from 'react';
import PurchaseOrderStatusDropdown from 'domain/finance/purchaseOrder/shared/input/PurchaseOrderStatusDropdown';

const PurchaseOrderStatusFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <PurchaseOrderStatusDropdown source={source} />
    </DropDownFilter>
  );
};

export default PurchaseOrderStatusFilter;
